import React, { Fragment, useEffect, useState } from 'react'
import { Container, Row, Col, Modal, Button } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../context/auth/useAuth'
import { Link } from 'react-router-dom'
import { getOrdersClientDelivered } from '../../actions/ordersActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import Version from '../../version'

export default function Ordersdelivered() { 
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {client} = useAuth()

	const [page, setPage] = useState(1)
	const [limit, setLimit] = useState(25)
	const [search, setSearch] = useState('')
	const [searchAux, setSearchAux] = useState('')
	const [totalRows, setTotalRows] = useState(0)

	const {orders, resultorder, total} = useSelector(state=>state.orders)

    const [modalShow, setModalShow] = useState(false)
    const [orderToShow, setOrderToShow] = useState({})

	useEffect(() => {
		window.scrollTo({
            top:0,
            behavior: 'instant'
        })
		if(client){
			dispatch(getOrdersClientDelivered(client?.id))
		}
	},[dispatch, t, client])

	useEffect(() => {
		if (client) {
			dispatch(getOrdersClientDelivered(client?.id, page, limit, search))
		}
	}, [page, limit, search])

	useEffect(() => {
		setTotalRows(total || 0)
	}, [total])

    const showOrder = (orderid) => {
		setOrderToShow(orders?.find(order => order._id === orderid))

		setModalShow(true)
    }

    useEffect(() => {
        if(resultorder){
            switch (resultorder) {
                case 'changedsuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.orders.changedsuccess')
                    }).then(() => {
                        setModalShow(false)
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultorder])

	const columnsOrders = [
		{
			name: t('admin.orders.reference'),
			id: 'id',
			cell: order =>
				<div className='text-center'>
					<strong>{order?.orderReference}</strong><br/>
					{order?.orderAt?.substr(11,5)}<br/>
					{order?.orderAt?.substr(8,2)+'/'+order?.orderAt?.substr(5,2)+'/'+order?.orderAt?.substr(0,4)}<br/>
				</div>,
			selector: (order) => order?.orderReference,
			sortable: true,
		},{
			name: t('admin.orders.order'),
			cell: order =>
				<div>
					{order?.restaurant}<br/>
					
                	
					{ new Date(Date.parse(order?.date)).getDate()<10 ? '0'+new Date(Date.parse(order?.date)).getDate() : new Date(Date.parse(order?.date)).getDate()}/{ new Date(Date.parse(order?.date)).getMonth()+1<9 ? '0'+parseInt(new Date(Date.parse(order?.date)).getMonth()+1) : parseInt(new Date(Date.parse(order?.date)).getMonth()+1)}/{ new Date(Date.parse(order?.date)).getFullYear()}<br/>
					{order?.hour}
				</div>,
			selector: (order) => order?.restaurant,
			sortable: true,
		},{
			name: t('admin.menus.price'),
			cell: order =>
				<div>
					{order?.price} €                    
				</div>,
			selector: (order) => order?.user?.name,
			sortable: false,
		},{
			name: '',
			cell: order =>
				<div>
					<label onClick={() => showOrder(order?._id)}>
						<i className="fa-solid fa-list"></i>
					</label>
				</div>,
			sortable: false,
		}
	]

	return (
        <Container className='p-5'>
            <Row className="mb-3">
                <Col xs={2} className='p-0'>
                    <Link className="p-0 my-3" to="/client/dashboard">
                        <img src="../images/arrow-back.svg" alt="arrow-back" width={25}></img>
                    </Link>
                </Col>
                <Col xs={8} className='text-center'>
                    <h1 className='fs-18'>{t('admin.orders.ordersdelivered')}</h1>
                </Col>
                <Col xs={2}></Col>
            </Row>            
            <Row>
				<Col className='p-0'>
					<div className="d-flex my-2">
						<input
							type="text"
							className="form-control me-2"
							placeholder={t("datatables.buscar")}
							value={searchAux || ""}
							onChange={e => {
								setSearchAux(e.target.value);
								setPage(1);
							}}
							onKeyDown={(e) => {if (e.key === 'Enter') { setSearch(searchAux); setPage(1); }}}
						/>
						<Button onClick={() => setSearch(searchAux)}><i className='fas fa-search'></i></Button>
					</div>
					{orders?.length > 0 ?
						<CustomDataTable
							columns={columnsOrders}
							data={orders}
							pagination
							paginationServer
							paginationTotalRows={totalRows}
							searchable={'custom'}
							searchText={search}
							onChangeRowsPerPage={(newLimit) => {
								setLimit(newLimit)
								setPage(1)
							}}
							onChangePage={(newPage) => {
								setPage(newPage)
							}}
						/>
                    :
                        <h4 className='mt-4 text-center'>{t('admin.orders.thereisnotordersdelivered')}</h4>
                	}
				</Col>
            </Row>
			<Row>
                <Col className='text-center mt-2'>
                    <Version />
                </Col>
            </Row>
            <Modal show={modalShow} className="sd-modal" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter" className='w-100 d-flex justify-content-between'>
						<div>{t('admin.orders.order')}: {orderToShow?.orderReference}</div>
						<div><i className='fa fa-times' onClick={() => setModalShow(false)}></i></div>
					</Modal.Title>
                    
                </Modal.Header>
                <Modal.Body>
                    <div className="px-4 formulario">
						<Row className="text-start my-3">
							<Col>
							<strong>{t('admin.orders.orderat')}: {orderToShow?.orderAt?.substr(11,5)+' ('+orderToShow?.orderAt?.substr(8,2)+'/'+orderToShow?.orderAt?.substr(5,2)+'/'+orderToShow?.orderAt?.substr(0,4)+')'}</strong><br/>
							<strong>{t('admin.menus.price')}: {orderToShow?.price} €</strong><br/>
							· {t('admin.orders.client')}: {orderToShow?.user}<br/>
							· {t('admin.orders.restaurant')}: {orderToShow?.restaurant}<br/>
							· {t('admin.orders.hour')}: {orderToShow?.hour+' ('+orderToShow?.date?.substr(8,2)+'/'+orderToShow?.orderAt?.substr(5,2)+'/'+orderToShow?.orderAt?.substr(0,4)+')'}<br/>
							· {t('admin.orders.firstdish')}: {orderToShow?.firstdish?.name}<br/>
							· {t('admin.orders.seconddish')}: {orderToShow?.seconddish?.name}<br/>
							· {t('admin.orders.drink')}: {orderToShow?.drink?.name}<br/>
							· {t('admin.orders.dessert')}: {orderToShow?.dessert?.name}<br/>
							{orderToShow?.complements?.length > 0 ?
									<Fragment>
										· {t('admin.orders.complements')}:<br/>
										{orderToShow?.complements?.map((complement, index) =>(
											<div key={index} className='ps-3'>{complement?.name}<br/></div>
										))}
									</Fragment>
								:
									<></>
							}
							</Col>
						</Row>
					</div>
                </Modal.Body>
            </Modal>
        </Container>
	)
}